class Monitoring.Methods.NotificationEventsListener

  # 25 seconds (allows for a 15s interval + 10s buffer for network jitter)
  WATCHDOG_TIMEOUT_MS: 25000

  HEARTBEAT_INTERVAL_MS: 600000

  constructor: () ->
    @listeners = []
    @watchdogTimer = null
    @heartbeatTimer = null
    @connectionErrorsCount = 0
    @eventsReceived = 0
    @keepAlivesReceived = 0

  eventSourceEnabled: () ->
    Keepcon.eventSourceChannelId?

  addEventListeners: (eventNames, eventHandler) ->
    return unless @eventSourceEnabled()

    @_logInvalidChannel() unless @_channelLooksValid()
    @loadListeners(eventNames, eventHandler)
    @connectAndBindListeners()
    @_startHeartbeat()

  loadListeners: (eventNames, eventHandler) ->
    _.each(eventNames, (eventName) =>
      @loadListener(eventName, eventHandler)
    )

  loadListener: (eventName, eventHandler) ->
    handlerFunction = (event) =>
      @_resetWatchdogTimer()
      @eventsReceived = @eventsReceived + 1
      try
        data = JSON.parse(event.data)
      catch e
        jsLogger.error("SSE event data is not valid JSON: #{event.data}")
        return
      eventHandler.handleEvent(_.extend({event_type: eventName}, data))

    @listeners.push({eventName: eventName, handlerFunction: handlerFunction})

  connectAndBindListeners: () ->
    _.each(@listeners, (listener) =>
      @bindListener(listener)
    )

  bindListener: (listener) ->
    @eventSourceConnection().addEventListener(listener.eventName, listener.handlerFunction)

  eventSourceConnection: () ->
    return @eventSource if @eventSource

    try
      @eventSource = new EventSource(Keepcon.eventSourceChannelId)
      @eventSource.addEventListener 'keepAlive', =>
        @keepAlivesReceived = @keepAlivesReceived + 1
        @_resetWatchdogTimer()

    catch error
      jsLogger.error(
        "Can't connect to ServerSentEvents (EventSource) for #{error} - " +
        "Date: #{new Date().toISOString()}"
      )
      return null

    @eventSource.onopen = (event) =>
      if @connectionErrorsCount >= 3
        $.noty.closeAll()
        noty({type: 'success', text: I18n.t('sse.connection_reestablished'), timeout: 8000})
      @connectionErrorsCount = 0
      @_logSuccessfulConnection()
      @_resetWatchdogTimer()

    @eventSource.onerror = (error) =>
      @connectionErrorsCount = @connectionErrorsCount + 1
      if @connectionErrorsCount == 3
        $.noty.closeAll()
        noty({type: 'alert', text: I18n.t('sse.connection_lost')})
      @_clearWatchdogTimer()
      try
        @_logDisconnection(error)

        # Manually recover from permanent closure
        if error.target?.readyState == EventSource.CLOSED
          jsLogger.warn("EventSource closed permanently. Tearing down and reconnecting...")
          @tearDownConnection()
          # Add a slight delay to prevent an infinite loop if the server is permanently down
          setTimeout((=> @connectAndBindListeners()), 5000)
      catch e
        jsLogger.error("EventSource onerror #{e}")

    @eventSource

  _logSuccessfulConnection: ->
    newRelicLogger.logSseConnectedEvent()
    jsLogger.info(
      "Connected to ServerSentEvents (EventSource) for #{Keepcon.eventSourceChannelId} - " +
      "Date: #{new Date().toISOString()}"
    )

  _logDisconnection: (error) ->
    newRelicLogger.logSseDisconnectedEvent(error)
    jsLogger.warn(
      "Disconnected from ServerSentEvents (EventSource) for #{Keepcon.eventSourceChannelId} - " +
      "error_type: #{error?.type} - " +
      "ready_state: #{@_readyState()} - " +
      "Date: #{new Date().toISOString()}"
    )

  tearDownConnection: () ->
    jsLogger.info("TearingDown Connection (EventSource) for #{Keepcon.eventSourceChannelId}")
    @_clearWatchdogTimer()
    @removeEventListeners() # but keep @listeners to bind them again after reconnecting!
    @eventSource?.close()
    @eventSource = null

  removeEventListeners: () ->
    return unless @eventSource

    _.each(@listeners, (listener) =>
      @eventSourceConnection()?.removeEventListener(listener['eventName'], listener['handlerFunction'])
    )

  # --- Watchdog Timer Methods ---

  _resetWatchdogTimer: ->
    @_clearWatchdogTimer()
    @watchdogTimer = setTimeout((=>
      jsLogger.warn("SSE Watchdog triggered! No keepAlive received in #{@WATCHDOG_TIMEOUT_MS}ms. Forcing reconnect...")
      @tearDownConnection()
      @connectAndBindListeners()
    ), @WATCHDOG_TIMEOUT_MS)

  _clearWatchdogTimer: ->
    clearTimeout(@watchdogTimer) if @watchdogTimer
    @watchdogTimer = null

  _startHeartbeat: ->
    return if @heartbeatTimer

    @heartbeatTimer = setInterval((=> @_logHeartbeat()), @HEARTBEAT_INTERVAL_MS)

  _logHeartbeat: ->
    jsLogger.info(
      'SSE Heartbeat | ' +
      "channel_id: #{Keepcon.eventSourceChannelId} - " +
      "ready_state: #{@_readyState()} - " +
      "events_received: #{@eventsReceived} - " +
      "keep_alives_received: #{@keepAlivesReceived} - " +
      "connection_errors: #{@connectionErrorsCount}"
    )

  _channelLooksValid: ->
    channel = Keepcon.eventSourceChannelId
    return false unless channel

    lastSegment = channel.split('/').pop()
    lastSegment != '' && lastSegment != 'null' && lastSegment != 'undefined'

  _logInvalidChannel: ->
    jsLogger.error("SSE Invalid channel | channel_id: #{Keepcon.eventSourceChannelId}")

  _readyState: ->
    if @eventSource then @eventSource.readyState else 'no-connection'

window.notificationsEventListener = new Monitoring.Methods.NotificationEventsListener()
